// extracted by mini-css-extract-plugin
module.exports = {"angle":"corner-module--angle--vV2-e"};